import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ListComponent} from './video/list/list.component';
import {AppComponent} from './app.component';
import {CategoryComponent} from './video/list/category.component';
import {ShowComponent} from './video/list/show.component';

@NgModule({
  imports: [
    RouterModule.forRoot([
        { path: 'app/list', component: ListComponent },
        {path: 'app/category', component: CategoryComponent },
        {path: 'app/show', component: ShowComponent },
         // {path: 'null', component: ShowComponent }
    ])
  ],
  exports: [RouterModule]
  // imports: [
  //   RouterModule.forChild([
  //     {
  //       path: '',
  //       component: AppComponent,
  //       children: [
  //         { path: '/list', component: ListComponent},
  //         { path: 'category', component: CategoryComponent}
  //       ]
  //     }
  //   ])
  // ],
  // exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts